/* =============================================================
   arije - Formulaire Rolex : point de vente

   ROLE
   Renseigner, dans l'e-mail recu, la boutique choisie ET l'adresse
   e-mail vers laquelle la demande doit etre routee :
     contact[Boutique]     -> nom du point de vente
     contact[Destinataire] -> e-mail de routage
     contact[provenance]   -> conserve pour compatibilite

   POURQUOI CETTE VERSION EST BLINDEE
   1) Le script inline d'origine ecrivait ces champs au CLIC du bouton
      Envoyer. Or assets/rolex-contact.js est charge avant, attache lui
      aussi un ecouteur au meme bouton, et appelle form.submit() : la
      valeur partait donc apres le formulaire.
   2) La premiere correction synchronisait au chargement et au
      « change ». Insuffisant : la selection peut changer SANS
      evenement « change » quand le navigateur restaure le formulaire
      apres un rechargement ou un retour arriere. Les champs caches
      (type=hidden) ne sont, eux, jamais restaures. On obtenait alors
      une selection Saint-Germain avec des champs caches restes sur
      Flagship.

   On ne fait donc plus confiance a l'ordre des evenements. La
   synchronisation a lieu :
     - au chargement (DOMContentLoaded ET load, car la restauration
       du navigateur intervient apres DOMContentLoaded) ;
     - au retour de bfcache (pageshow) ;
     - a chaque changement de selection (change) ;
     - au clic sur Envoyer, en phase de CAPTURE, donc avant
       l'ecouteur de rolex-contact.js qui fait stopPropagation ;
     - et surtout dans form.submit() lui-meme, qui est enveloppe.

   Ce dernier point est le filet decisif : form.submit() appele par du
   JS ne declenche PAS l'evenement « submit », un addEventListener
   ('submit') ne suffit donc pas. En enveloppant la methode, les champs
   sont ecrits a l'instant exact du POST, quel que soit l'etat anterieur.

   NE PAS remplacer l'enveloppe de form.submit par un simple ecouteur
   « submit » : ce serait reintroduire le bug.
   ============================================================= */

(function () {
  'use strict';

  var ID_FORMULAIRE = 'RolexContactForm';
  var ID_SELECTEUR = 'contact-rolex-address';
  var ID_BOUTON = 'rolex-contact-send';

  function selecteur() {
    return document.getElementById(ID_SELECTEUR);
  }

  function synchroniser() {
    var s = selecteur();
    if (!s) return;

    var option = s.options[s.selectedIndex];
    if (!option) return;

    var nom = option.getAttribute('data-rolex-nom') || option.value || '';
    var email = option.getAttribute('data-rolex-email') || '';

    var champNom = document.getElementById('rolex-pos-name');
    var champEmail = document.getElementById('rolex-pos-email');
    var champProvenance = document.getElementById('ContactForm-provenance');

    if (champNom) champNom.value = nom;
    if (champEmail) champEmail.value = email;
    if (champProvenance) champProvenance.value = 'Formulaire contact Rolex - ' + nom;
  }

  /* Expose pour diagnostic manuel depuis la console du navigateur. */
  window.arijeSynchroniserPointDeVente = synchroniser;

  function brancher() {
    var s = selecteur();
    if (!s) return;

    if (s.getAttribute('data-rolex-branche') !== '1') {
      s.addEventListener('change', synchroniser);
      s.setAttribute('data-rolex-branche', '1');
    }

    var formulaire = document.getElementById(ID_FORMULAIRE);
    if (formulaire && formulaire.getAttribute('data-rolex-branche') !== '1') {
      var soumissionNative = formulaire.submit;
      formulaire.submit = function () {
        synchroniser();
        return soumissionNative.apply(this, arguments);
      };
      formulaire.addEventListener('submit', synchroniser, true);
      formulaire.setAttribute('data-rolex-branche', '1');
    }

    synchroniser();
  }

  /* Capture au niveau du document : s'execute avant l'ecouteur de
     rolex-contact.js, qui est en phase de bouillonnement. */
  document.addEventListener(
    'click',
    function (ev) {
      var cible = ev.target;
      if (!cible || !cible.closest) return;
      if (cible.closest('#' + ID_BOUTON)) synchroniser();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancher);
  } else {
    brancher();
  }

  window.addEventListener('load', brancher);
  window.addEventListener('pageshow', brancher);
})();
